import { Dispatch, SetStateAction, useCallback, useEffect } from "react";
import ModalConfirmUsername from "../../../modals/modal-confirm-username/modal-confirm-username";
import ModalSaveUrl from "../../../modals/modal-save-url/modal-save-url";
import ModalValidateUsername from "../../../modals/modal-validate-username/modal-validate-username";
import { HookObjectivePostType } from "../../../../hooks/useObjectivePost";


interface ModalsProcessProps {
  modalSaveUsername: boolean; 
  setModalSaveUsername: Dispatch<SetStateAction<boolean>>;
  modalConfirm: boolean; 
  setModalConfirm: Dispatch<SetStateAction<boolean>>; 
  modalSaveUrlPost: boolean;
  setModalSaveUrlPost: Dispatch<SetStateAction<boolean>>;
  handleContinue: ()=> void;
  hookObjectivePost: HookObjectivePostType;
}


const ModalsProcess: React.FC<ModalsProcessProps> = ({
  modalSaveUsername,
  setModalSaveUsername,
  modalConfirm,
  setModalConfirm,
  modalSaveUrlPost,
  setModalSaveUrlPost,
  handleContinue,
  hookObjectivePost,
}) => {

  const {
    loading,
    processUsername,
    processUrl,
    isSaveUsername,
    username, 
    handleChangeUsername, 
    handleSubmitUsername,
    urlPost,
    postSaved,
    isSavePost,
    confirm,
    error,
    handleChangeUrlPost,
    handleSubmitUrlPost,
    handleConfirm,
    handleCancelConfirm,
    socialMediaSelected
  } = hookObjectivePost;

  const handleCancelConfirmModal = useCallback(()=>{
    handleCancelConfirm();
    setModalConfirm(false);
    setModalSaveUsername(true);
  }, [handleCancelConfirm, setModalConfirm, setModalSaveUsername]);


  useEffect(()=>{
    if(isSaveUsername && !confirm){
      setModalConfirm(true);
    }
  },[isSaveUsername, confirm, setModalConfirm]);

  useEffect(()=>{
    if(isSavePost){
      setModalSaveUrlPost(false);
    }
  },[isSavePost, setModalSaveUrlPost]);
  
  return (
    <>
      <ModalValidateUsername 
        open={modalSaveUsername} 
        setOpen={setModalSaveUsername}
        process={processUsername}
        loading={loading}
        value={username}
        setValue={handleChangeUsername}
        handleSubmitUsername={handleSubmitUsername}
        socialMediaName={socialMediaSelected?.name ?? ''}
        error={error}
      />
      <ModalConfirmUsername 
        open={Boolean(modalConfirm && postSaved)}
        setOpen={setModalConfirm}
        success={confirm}
        onCancel={handleCancelConfirmModal}
        onConfirm={handleConfirm}
        onContinue={handleContinue}
        loading={loading}
        url={postSaved}
        socialMediaName={socialMediaSelected?.name ?? ''}
        error={error}
      /> 
      <ModalSaveUrl
        open={modalSaveUrlPost}
        setOpen={setModalSaveUrlPost}
        handleSubmitUrl={handleSubmitUrlPost}
        process={processUrl}
        loading={loading}
        value={urlPost}
        setValue={handleChangeUrlPost}
        socialMediaName={socialMediaSelected?.name ?? ''}
        error={error}
      />
    </>
  )
};

export default ModalsProcess;